/**
 * Segment integration, used to send data to segment app
 */
/* @ngInject */
function segmentService ($window, $rootScope) {
  var api = {
    initialize,
    track,
    page
  }
  return api

  /**
   * Initializes the intercom integration.
   * @param {oParams} object - Parameter used on integration services.
   * @param {oParams.user} object - User data.
   * @param {oParams.company} object - Customer Company data.
   */
  function initialize (oParams) {
    const { user, company, oUserCompanyConfigurations } = oParams

    const userTraits = {
      email: user.email,
      name: user.name,
      role: user.role,
      onboarding_status: user.onboarding_status,
      onboarding_job: user.onboarding_job,
      locale: user.locale,
      company_name: company.formattedName,
      company_id: company.id,
      SSOAccess: user.SSOAccess,
      social_media_connected: user?.socialAccounts?.length || 0,
      consultant: !!user.isGroupOwner
    }

    const companyTraits = {
      id: company.id,
      company_id: company.id,
      name: company.formattedName,
      company_status: company.status,
      created_at: company.createdAt,
      activeUsersQuota: company.maxLicenses,
      size: company.size,
      graphic_integration_enabled: oUserCompanyConfigurations.ENABLE_PRINT_SHOP,
      support_email: oUserCompanyConfigurations.SUPPORT_EMAIL,
      pricing_package: company.billingPackage.plan.pricingPackage.name,
      pricing_plan: company.billingPackage.plan.name,
      file_has_new_version: true,
      social_media_enabled: oUserCompanyConfigurations.ENABLE_SOCIAL_MEDIA
    }

    $window.analytics.identify(user.id, {
      ...userTraits
    })

    $window.analytics.group(company.id, {
      ...companyTraits
    })

    if ($window.userGuiding) {
      $window.userGuiding.identify(user.id, {
        ...userTraits,
        company: {
          ...companyTraits
        },
        company_status: company.status,
        company_pricing_package: company.billingPackage.plan.pricingPackage.name,
        company_pricing_plan: company.billingPackage.plan.name,
        company_social_media_enabled: oUserCompanyConfigurations.ENABLE_SOCIAL_MEDIA
      })
    }

    return oParams
  }

  function track (eventName, metadata) {
    if (!$window.analytics || !eventName || !$rootScope.oUser) {
      return
    }

    metadata = metadata || {}

    if ($rootScope.oUserCompany) {
      metadata.company_id = $rootScope.oUserCompany.id
    }

    $window.analytics.track(eventName, metadata)

    if ($window.userGuiding) {
      $window.userGuiding.track(eventName, metadata)
    }
  }

  function page (pageName, params) {
    if (!$window.analytics || !pageName || !$rootScope.oUser) {
      return
    }
    params = params || {}

    $window.analytics.page(pageName, params)
  }
}

export { segmentService }
